export default __webpack_public_path__ + "static/media/navbar-summary-orange.d52c0880.svg";